import React from 'react';
import { useNavigate } from 'react-router-dom';

const SeriesContinuationCard = ({ story, onDismiss }) => {
  const navigate = useNavigate();

  if (!story?.seriesId) return null;

  const nextChapter = (story.chapterNumber || 1) + 1;
  const seriesTitle = story.seriesTitle || 'a series';
  const theme = story.theme || '';

  const handleContinue = () => {
    const params = new URLSearchParams({
      seriesId: story.seriesId,
      chapter: String(nextChapter),
    });
    if (theme) params.set('theme', theme);
    navigate(`/dashboard/generate?${params.toString()}`);
  };

  return (
    <div
      className="rounded-4 p-4"
      style={{
        background: 'linear-gradient(135deg, #1a0a3d, #2d1b69)',
        color: 'white',
        marginTop: '24px',
      }}
    >
      <div
        style={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: '20px',
          marginBottom: '6px',
        }}
      >
        The adventure continues... ✨
      </div>
      <p
        style={{
          fontSize: '14px',
          color: 'rgba(255,255,255,0.8)',
          marginBottom: '20px',
        }}
      >
        This is part of <strong>{seriesTitle}</strong>. Want to generate Chapter {nextChapter} tonight?
      </p>
      <div className="d-flex gap-3 flex-wrap">
        <button
          className="btn btn-dream rounded-pill px-4"
          style={{ background: 'linear-gradient(135deg, #6f42c1, #9b59b6)', color: '#fff', border: 'none' }}
          onClick={handleContinue}
        >
          Continue the adventure →
        </button>
        <button
          className="btn rounded-pill px-4"
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.4)',
            color: 'rgba(255,255,255,0.8)',
          }}
          onClick={onDismiss}
        >
          Not tonight
        </button>
      </div>
    </div>
  );
};

export default SeriesContinuationCard;
